/**
 * Default container for portaled overlays (dialogs, dropdowns, selects, popovers).
 *
 * Radix portals attach to `<body>` by default, which lives OUTSIDE the
 * `.app-shell` wrapper that the signage / my / ping dashboard shells set up.
 * Token-driven classes like `bg-popover` / `text-popover-foreground` then
 * resolve against the bare `:root` instead of the shell's scope, so an overlay
 * can render in the wrong mode (e.g. a white modal over a dark app).
 *
 * Portaling overlays INTO the shell instead makes them inherit the exact same
 * tokens as the page, so a modal is always the same mode as the app behind it —
 * dark panels → dark modal, light panels → light modal. When there is no shell
 * on the page (e.g. the auth app or a public Ping page) this returns
 * `undefined`, which Radix treats as "portal to <body>" — still consistent
 * with that page's own scope.
 *
 * This is the single source of truth for the "modals follow the app theme"
 * rule; every overlay primitive (Dialog, DropdownMenu, Select, …) reads it so
 * the behaviour can never drift per-call-site.
 */
export function getOverlayContainer(): HTMLElement | undefined {
  if (typeof document === 'undefined') return undefined
  return (document.querySelector('.app-shell') as HTMLElement | null) ?? undefined
}
